import React, { useState } from "react";
import styled from "styled-components";
import Header from '../components/Header';
import { useProfile } from "../context/ProfileContext";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
 background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 8px 0;
  box-sizing: border-box;
  width: 100vw;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  width: 100%;
  max-width: 420px;
  min-width: 0;
  border: 1px solid #b2c8b2;
  box-sizing: border-box;

  @media (max-width: 500px) {
    max-width: 100vw;
    border-radius: 0;
    box-shadow: none;
    border-left: none;
    border-right: none;
  }
`;

const SectionHeader = styled.div`
 background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  color: #fff;
  font-weight: bold;
  font-size: 1.1rem;
  text-align: center;
  padding: 10px 0;
  border-bottom: 1px solid #b2c8b2;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;
  table-layout: fixed;
  word-break: break-word;
`;

const TdLabel = styled.td`
  padding: 8px 12px;
  border-bottom: 1px solid #b2c8b2;
  font-weight: 500;
  background: #f8f8f8;
  width: 50%;
  word-break: break-word;

  @media (max-width: 500px) {
    padding: 8px 6px;
    font-size: 0.98rem;
  }
`;

const TdValue = styled.td`
  padding: 8px 12px;
  border-bottom: 1px solid #b2c8b2;
  background: #fff;
  width: 50%;
  word-break: break-word;

  @media (max-width: 500px) {
    padding: 8px 6px;
    font-size: 0.98rem;
  }
`;

const RateRow = styled.tr`
  td {
    border-bottom: none;
    background: #fff;
  }
`;

const RateInput = styled.select`
  padding: 4px 8px;
  font-size: 1rem;
  margin-right: 10px;
  max-width: 60px;

  @media (max-width: 500px) {
    font-size: 0.98rem;
    padding: 3px 6px;
  }
`;

const UpdateButton = styled.button`
 background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  color: #fff;
  border: 1px solid #7fa18c;
  border-radius: 2px;
  padding: 6px 22px;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  margin-left: 10px;
  transition: background 0.2s;
  &:hover {
   background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  }
  @media (max-width: 500px) {
    padding: 5px 12px;
    font-size: 0.98rem;
    margin-left: 6px;
  }
`;

const FooterButton = styled.button`
  width: 100%;
background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  color: #fff;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 12px 0;
  margin-top: 0;
  cursor: pointer;
  border-radius: 0;
  transition: background 0.2s;
  &:hover {
   background:
  radial-gradient(circle at center, rgba(59, 89, 152, 0.4), transparent 70%),
  linear-gradient(90deg, #0a244d 0%, #1a3a6d 40%, #3b5998 60%, #0a244d 100%);
  }
  @media (max-width: 500px) {
    font-size: 1rem;
    padding: 10px 0;
  }
`;

const Profile = () => {
  const [rateDiff, setRateDiff] = useState("0");
  const {profile} = useProfile();
  const navigate = useNavigate();
  return (
    <>
     <Header/>
   
    <Container>
      <Card>
        <SectionHeader>RATE INFORMATION</SectionHeader>
        <Table>
          <tbody>
            <RateRow>
              <TdLabel>Rate Difference :</TdLabel>
              <TdValue>
                <RateInput value={rateDiff} onChange={e => setRateDiff(e.target.value)}>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </RateInput>
                <UpdateButton>UPDATE</UpdateButton>
              </TdValue>
            </RateRow>
          </tbody>
        </Table>
        <SectionHeader>PERSONAL INFORMATION</SectionHeader>
        <Table>
          <tbody>
            <tr>
              <TdLabel>Client Name :</TdLabel>
              <TdValue>N/A</TdValue>
            </tr>
            <tr>
              <TdLabel>Client Code :</TdLabel>
              <TdValue>{profile.userNo}</TdValue>
            </tr>
            <tr>
              <TdLabel>Chips :</TdLabel>
              <TdValue>{profile.walletBalance}</TdValue>
            </tr>
            <tr>
              <TdLabel>Contact No :</TdLabel>
              <TdValue>{profile.username}</TdValue>
            </tr>
            <tr>
              <TdLabel>Date Of Joining :</TdLabel>
              <TdValue>25-05-2025</TdValue>
            </tr>
            <tr>
              <TdLabel>Address :</TdLabel>
              <TdValue>INDIA</TdValue>
            </tr>
          </tbody>
        </Table>
        <SectionHeader>COMPANY INFORMATION</SectionHeader>
        <Table>
          <tbody>
            <tr>
              <TdLabel>HELP LINE NO :</TdLabel>
              <TdValue>+91-1234567890</TdValue>
            </tr>
          </tbody>
        </Table>
        <FooterButton onClick={()=>navigate(-1)}>BACK TO MAIN MENU</FooterButton>
      </Card>
    </Container>
    </>
  );
};

export default Profile;
